import React, { useEffect, useState } from "react";
import './Comment.scss';
import {decrypt} from "../../utilities/Encriptacion";
import CustomSelect from "../../components/atoms/SelectInput/SelectInput";
import {addComments, getRoutesByClient} from "./Comment.service";
import Alert from "../../components/atoms/Alert/Alert";


interface Route {
    ID: number | undefined;
    NOMBRE: string | undefined;
    CHOFER: number | undefined;
    ID_UNIDAD: number | undefined;
    ID_TRAZO: number | undefined;
    TIPO: number | undefined;
    ID_BITACORA: number | undefined;
}

const Comments: React.FC = () => {
    const [routes, setRoutes] = useState<Route[]>([]);
    const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION!;
    const encryptedData = sessionStorage.getItem('dataClient');
    const data = decrypt(encryptedData, CLAVE);
    const company = JSON.parse(data).name;
    const companyId = JSON.parse(data).id;
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState(''); // 'success' o 'error'
    const [alertMessage, setAlertMessage] = useState('');

    const [formData, setFormData] = useState({
        date: new Date(),
        client: companyId,
        routeId: "",
        employeeNumber: "",
        name: "",
        email: "",
        issue: "",
        comments: "",
    });

    useEffect(() => {
        if(companyId) {
            getRoutesByClient(setRoutes, companyId);
        }
    }, [companyId]);

    const handleChange = (e: { target: { name: any; value: any; }; }) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        if (formData.routeId) {
            addComments(formData)
                .then(r => {
                    setAlertType('success');
                    setAlertMessage(r);
                    setShowAlert(true);
                })
                .catch((err) => {
                    setAlertType('error');
                    setAlertMessage(err);
                    console.log(err)
                    setShowAlert(true);
                });
        }
    };

    const handleRouteSelect = (route: { ID_RUTA: any; }) => {
        setFormData((prevData) => ({
            ...prevData,
            routeId: route.ID_RUTA,
        }));
    };

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    return (
            <div className="comment-form">
                <h2>Agregar Comentario</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <CustomSelect
                            label="ID Ruta *"
                            options={routes}
                            onSelect={handleRouteSelect}
                        />
                    </div>
                    <div className="form-group">
                        <label>Número de Empleado</label>
                        <input
                            type="text"
                            name="employeeNumber"
                            value={formData.employeeNumber}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>Nombre</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>Correo*</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Asunto *</label>
                        <input
                            type="text"
                            name="issue"
                            value={formData.issue}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Comentarios *</label>
                        <textarea
                            name="comments"
                            value={formData.comments}
                            onChange={handleChange}
                            required
                        ></textarea>
                    </div>
                    <button type="submit">Enviar Comentario</button>
                </form>
                {showAlert && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        duration={8000}
                        onClose={handleCloseAlert}
                    />
                )}
            </div>
    )
}

export default Comments;